<template>
	<tr>
		<td class="border-top-0">
			<div class="input-group pt-2">
				<label class="label-toggle d-block">
					<input type="checkbox" class="toggle" v-model="status" v-on:change="changeStatus">
					<div class="toggle-btn d-inline-block"></div>
				</label>
			</div>
		</td>
		<td class="border-top-0">
			<div class="pt-2">{{ titleCase(day) }}</div>
		</td>
		<td class="border-top-0">
			<div class="form-group time-picker-content">
				<div class="input-group">
					<multiselect
						class="form-control"
						v-model="start"
						:options="startHours"
						:show-labels="false"
						:allow-empty="false"
						:preselect-first="true"
						track-by="name"
						label="name"
						@select="changeStartTime"
						:placeholder="''">
						<span slot="caret"></span>
					</multiselect>
					<div class="input-group-append">
						<span class="input-group-text" id="basic-addon2">hour</span>
					</div>
				</div>
			</div>
		</td>
		<td class="border-top-0">
			<div class="form-group time-picker-content">
				<div class="input-group">
					<multiselect
						class="form-control"
						v-model="end"
						:options="endHours"
						:show-labels="false"
						:allow-empty="false"
						:preselect-first="true"
						track-by="name"
						label="name"
						@select="changeEndTime"
						:placeholder="''">
						<span slot="caret"></span>
					</multiselect>
					<div class="input-group-append">
						<span class="input-group-text" id="basic-addon2">hour</span>
					</div>
				</div>
			</div>
		</td>
	</tr>
</template>
<script>
import { mapActions } from 'vuex';
import { toTitleCase } from '../lib/helper';

export default {
	props: {
		day: {
			type: String,
		},
		schedule: {},
	},
	data() {
		return {
			isLoading: false,
			status: false,
			start: '',
			end: '',
			hours: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
			startHours: [
				{
					name: '0',
					$isDisabled: false,
				}, {
					name: '1',
					$isDisabled: false,
				}, {
					name: '2',
					$isDisabled: false,
				}, {
					name: '3',
					$isDisabled: false,
				}, {
					name: '4',
					$isDisabled: false,
				}, {
					name: '5',
					$isDisabled: false,
				}, {
					name: '6',
					$isDisabled: false,
				}, {
					name: '7',
					$isDisabled: false,
				}, {
					name: '8',
					$isDisabled: false,
				}, {
					name: '9',
					$isDisabled: false,
				}, {
					name: '10',
					$isDisabled: false,
				}, {
					name: '11',
					$isDisabled: false,
				}, {
					name: '12',
					$isDisabled: false,
				}, {
					name: '13',
					$isDisabled: false,
				}, {
					name: '14',
					$isDisabled: false,
				}, {
					name: '15',
					$isDisabled: false,
				}, {
					name: '16',
					$isDisabled: false,
				}, {
					name: '17',
					$isDisabled: false,
				}, {
					name: '18',
					$isDisabled: false,
				}, {
					name: '19',
					$isDisabled: false,
				}, {
					name: '20',
					$isDisabled: false,
				}, {
					name: '21',
					$isDisabled: false,
				}, {
					name: '22',
					$isDisabled: false,
				}, {
					name: '23',
					$isDisabled: false,
				},
			],
			endHours: [
				{
					name: '1',
					$isDisabled: false,
				}, {
					name: '2',
					$isDisabled: false,
				}, {
					name: '3',
					$isDisabled: false,
				}, {
					name: '4',
					$isDisabled: false,
				}, {
					name: '5',
					$isDisabled: false,
				}, {
					name: '6',
					$isDisabled: false,
				}, {
					name: '7',
					$isDisabled: false,
				}, {
					name: '8',
					$isDisabled: false,
				}, {
					name: '9',
					$isDisabled: false,
				}, {
					name: '10',
					$isDisabled: false,
				}, {
					name: '11',
					$isDisabled: false,
				}, {
					name: '12',
					$isDisabled: false,
				}, {
					name: '13',
					$isDisabled: false,
				}, {
					name: '14',
					$isDisabled: false,
				}, {
					name: '15',
					$isDisabled: false,
				}, {
					name: '16',
					$isDisabled: false,
				}, {
					name: '17',
					$isDisabled: false,
				}, {
					name: '18',
					$isDisabled: false,
				}, {
					name: '19',
					$isDisabled: false,
				}, {
					name: '20',
					$isDisabled: false,
				}, {
					name: '21',
					$isDisabled: false,
				}, {
					name: '22',
					$isDisabled: false,
				}, {
					name: '23',
					$isDisabled: false,
				}, {
					name: '24',
					$isDisabled: false,
				},
			],
		};
	},
	created() {
		this.setDefault();
	},
	methods: {
		...mapActions({
			updateSchedule: 'members/updateSchedule',
		}),
		titleCase(val) {
			return toTitleCase(val);
		},
		setDefault() {
			if (this.schedule) {
				const start = this.schedule.start.toString();
				const end = this.schedule.end.toString();
				this.status = this.schedule.enabled;
				this.start = { name: start, $isDisabled: false };
				this.end = { name: end, $isDisabled: false };
				this.checkEndHours(this.start);
			}
		},
		changeStatus() {
			const data = {
				key: this.day,
				value: this.status,
				type: 'status',
			};
			this.updateSchedule(data);
		},
		changeStartTime(value) {
			const data = {
				key: this.day,
				value: value.name,
				type: 'start',
			};
			this.updateSchedule(data);

			const start = parseInt(value.name);
			const end = parseInt(this.end.name);
			const newEnd = start + 1;
			this.checkEndHours(value);

			if (end <= start) {
				this.end = { name: newEnd.toString(), $isDisabled: false };
				this.changeEndTime(this.end);
			}
		},
		changeEndTime(value) {
			const data = {
				key: this.day,
				value: value.name,
				type: 'end',
			};
			this.updateSchedule(data);
		},
		checkEndHours(startTime) {
			const start = parseInt(startTime.name);
			const hours = this.endHours.map((curr) => {
				curr.$isDisabled = false;
				if (parseInt(curr.name) <= start) {
					curr.$isDisabled = true;
				}
				return curr;
			});
			this.endHours = hours;
		},
	},
	watch: {
		schedule() {
			this.setDefault();
		},
	},
};
</script>
<style scoped>
.time-picker-content {
	width: 140px;
	max-width: 140px;
}
</style>
